import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { IconButtonProps } from '@mui/material';
import { Collapse, IconButton } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { adaptV4Theme, createTheme } from '@mui/material/styles';
import { isEmpty } from 'lodash';
import type { ReactElement } from 'react';
import { useState } from 'react';
import styles from 'src/Jobs/JobsTableStyles';
import theme from 'src/theme';

interface JsonNotesProps {
  notes: Record<string, string | number | boolean>;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const JsonNotes = ({ notes }: JsonNotesProps): ReactElement => {
  const classes = styles();
  const [expanded, setExpanded] = useState<boolean>(false);
  const defaultTheme: Theme = createTheme(adaptV4Theme(theme));

  const ExpandMore = ({ expand, ...other }: ExpandMoreProps): ReactElement => {
    return (
      <IconButton
        {...other}
        style={{
          transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
          marginLeft: 'auto',
          transition: defaultTheme.transitions.create('transform', {
            duration: defaultTheme.transitions.duration.shortest,
          }),
        }}
        size="large"
      />
    );
  };

  const handleExpandClick = (): void => {
    setExpanded(!expanded);
  };

  if (isEmpty(notes)) {
    return <span></span>;
  }

  return (
    <div>
      <div className={classes.iconButtonContainer}>
        <ExpandMore expand={expanded} onClick={handleExpandClick}>
          <ExpandMoreIcon className={classes.iconButton} />
        </ExpandMore>
      </div>
      <Collapse in={expanded}>
        {Object.keys(notes).map((key: string) => {
          return (
            <div key={key}>
              <span style={{ fontWeight: 700 }}>{key}:</span>
              <span>{` ${notes[key]}`}</span>
            </div>
          );
        })}
      </Collapse>
    </div>
  );
};

export default JsonNotes;
